import { Field } from '../Field';
import AutocompleteElement from './AutocompleteElement';

export const Autocomplete = Field(AutocompleteElement);
